module.exports = __webpack_public_path__ + "media/images/covid/banner/en-17da448e0d6120efe6184e67da91e1f4.jpg";